import { CurrencyFormatter } from 'Helpers'
import { formatString } from 'Helpers/formatString'
import { TimeConverter } from 'Helpers/TimeConverter'
import { RecentInvestment } from 'Pages/Frontend/Interface/Dashboard/DashboardOverviewV2'
import investorTokenAssetsService, { InvestorTokenAsset } from 'Services/investorTokenAssetsService'
import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'

const DashRecentTransactions = () => {
  const [recentInvestmentsLoading, setRecentInvestmentsLoading] = useState(false)
  const [recentInvestmentsError, setRecentInvestmentsError] = useState<string | null>(null)
  const [recentInvestments, setRecentInvestments] = useState<InvestorTokenAsset[]>([])

  const fetchRecentInvestments = async () => {
    setRecentInvestmentsLoading(true)
    setRecentInvestmentsError(null)

    await investorTokenAssetsService
      .list({
        pageNumber: 1,
        pageSize: 7,
        sortOrder: 'DESC',
        status: 'ACTIVE',
      })
      .then(
        (response) => {
          const data = response?.data?.data

          console.log({ setRecentInvestments: data?.dataset })
          setRecentInvestments((data?.dataset ?? []).slice(0, 7) as RecentInvestment[])
          setRecentInvestmentsLoading(false)
        },
        (e) => {
          setRecentInvestments([])
          setRecentInvestmentsError(
            typeof e === 'object' && e !== null && 'message' in e
              ? String((e as { message?: unknown }).message ?? 'Failed to load recent investments')
              : 'Failed to load recent investments',
          )
          setRecentInvestmentsLoading(false)
        },
      )
  }

  useEffect(() => {
    fetchRecentInvestments()
  }, [])

  return (
    <div className='recent-investment'>
      <div className='admin-card recent-investment-card'>
        <div className='admin-card__header recent-investment-card__header'>
          <div>
            <div className='admin-card__title'>Recent Transactions</div>
            <div className='recent-investment-card__subtitle'>
              Latest 7 investor token asset purchases
            </div>
          </div>
          <Link to='/blockchain/token-assets/ACTIVE'>
            <div className='recent-investment-card__pill'>View All</div>
          </Link>
        </div>

        <div className='recent-investment-list'>
          {recentInvestmentsLoading ? (
            <div className='recent-investment-list__empty'>Loading recent investments...</div>
          ) : recentInvestmentsError ? (
            <div className='recent-investment-list__empty'>{recentInvestmentsError}</div>
          ) : recentInvestments.length === 0 ? (
            <div className='recent-investment-list__empty'>No recent investments found</div>
          ) : (
            recentInvestments.map((investment: InvestorTokenAsset, index) => {
              return (
                <div className='recent-investment-item' key={investment.id}>
                  <div className='recent-investment-item__index'>{index + 1}</div>

                  <div className='recent-investment-item__content'>
                    <div className='recent-investment-item__top'>
                      <div className='recent-investment-item__title'>
                        {investment?.createdByUser?.firstName}{' '}
                        {investment?.createdByUser?.firstName}
                      </div>
                      <div className='recent-investment-item__amount'>
                        ₦{CurrencyFormatter(Number(investment.principalNairaMajor ?? 0))}
                      </div>
                    </div>

                    <div className='recent-investment-item__bottom'>
                      <span className='recent-investment-item__meta'>{investment.id}</span>
                      <span className='recent-investment-item__meta'>
                        {/* {investment?.shares && investment?.shares[0]?.tokenCountOwned ?? 0} tokens */}
                      </span>
                      <span className='recent-investment-item__meta'>
                        {TimeConverter(investment.createdAt)}
                      </span>
                      <span
                        className={[
                          'recent-investment-item__status',
                          `recent-investment-item__status--${String('unknown').toLowerCase()}`,
                        ]
                          .filter(Boolean)
                          .join(' ')}
                      >
                        {formatString(investment.status)}
                      </span>
                    </div>
                  </div>
                </div>
              )
            })
          )}
        </div>
      </div>
    </div>
  )
}

export default DashRecentTransactions
